import React, { Component } from "react";
import messageType from "../../constants/message_types";

const messageTypeClasses = {
  [messageType.Success]: "alert-success",
  [messageType.Error]: "alert-danger",
  [messageType.Warning]: "alert-warning",
  [messageType.Info]: "alert-info",
};

class MessageBar extends Component {
  constructor(props) {
    super(props);
    this.firstRenderComplete = false;
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (Boolean(nextProps.messageUUID) && !this.props.messageUUID && !this.firstRenderComplete) {
      this.firstRenderComplete = true;
    }
  }

  render() {
    var visible = Boolean(this.props.messageUUID);
    var alertStyle = messageTypeClasses[this.props.messageType];
    return (
      <div
        className={
          "message-bar" +
          (visible ? " message-bar--visible" : " message-bar--invisible") +
          (this.firstRenderComplete ? "" : " message-bar--hidden")
        }>
        <div className={"alert alert-dismissible " + alertStyle} role="alert">
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
            onClick={() => {
              this.props.dismissMessageBar(this.props.messageUUID);
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
          {this.props.message}
        </div>
      </div>
    );
  }
}

export default MessageBar;
